// Relative paths are handled by the app router. Other URLs return null
// so the existing link handling can take care of them.
export function getInAppNotificationPath(link?: string | null): string | null {
  const trimmed = link?.trim();
  if (!trimmed || !trimmed.startsWith("/")) return null;

  try {
    const resolved = new URL(trimmed, window.location.origin);
    return resolved.origin === window.location.origin ? trimmed : null;
  } catch {
    return null;
  }
}
